<template>
    <div class="invite-code">
        <div class="banner"></div>
        <div class="invite-code-form">
            <h3>邀请码</h3>
            <input type="text" v-model="inviteCode" placeholder="请输入邀请码">
            <p class="error-message">{{errorMessage}}</p>
            <button :class="{'send-form':true,'sending':messageSending}" ref="sendBtn" @click="sendCode">确定</button>
            <div class="invite-code-intro">
                <h4>邀请码如何获取？</h4>
                <p>邀请码用于浏览本站所有剧本内容。您可以发送申请邮件至 “loukeyan@beimen.com”， 待通过后，将会回复您一个邀请码。 进入个人中心点击“邀请码”，输入后，即可浏览该剧本。</p>
            </div>
        </div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
import {SetCookie} from '@/assets/api/cookie'
export default {
    name:'InviteCode',
    data(){
        return{
            errorMessage:'',           //报错信息
            inviteCode:'',             //输入的邀请码
            sendDisabled:false,       //控制发送按钮可点击状态
            messageSending:false,     //发送中按钮样式
        } 
    },
    methods:{
        sendCode(){
            if(this.inviteCode==''){
                this.errorMessage="请输入您的邀请码"
            }else{
                this.sendDisabled=true
                this.messageSending=true
                this.$refs.sendBtn.innerHTML="发送中..."
                Axios.get('/common/invite/'+this.inviteCode)
                .then(
                    response=>{
						if(response.data.code===200&&response.data.data.errcode===2300){
							this.errorMessage="邀请码不正确"
							this.sendDisabled=false
							this.messageSending=false
							this.$refs.sendBtn.innerHTML="发送"
                        }else if(response.data.code===200&&response.data.data.errcode===2301){
							this.errorMessage="邀请码已失效"
							this.sendDisabled=false
							this.messageSending=false
							this.$refs.sendBtn.innerHTML="发送"
						}else if(response.data.code===200&&response.data.data.errcode===2302){
							this.errorMessage="邀请码已使用"
							this.sendDisabled=false
							this.messageSending=false
							this.$refs.sendBtn.innerHTML="发送"
                        }else if(response.data.code===200&&response.data.data=="验证成功"){
                            this.errorMessage=""
							this.sendDisabled=false
							this.messageSending=false
							this.$refs.sendBtn.innerHTML="发送"
							this.inviteCode=""
							SetCookie('v',"VIP")
							this.$swal({
								text:'验证成功',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1200,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							})
                        }
                    }
                ).catch(
                    error=>{
                        this.sendDisabled=false
                        this.messageSending=false
                        this.$refs.sendBtn.innerHTML="发送"
						this.$swal({
							text:'网络错误请稍后重试',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						})
                    }
                )
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .invite-code{
        padding-top:88px;
        .banner{
            width:750px;
            height:120px;
            background:url('../assets/img/banner.png') no-repeat;
            background-size:cover;
        }
        .invite-code-form{
            padding:60px 54px;
            h3{
                font-size:30px;
                color:#222;
                font-weight:bold;
                margin-bottom:54px;
            }
            input{
                width:600px;
                height:70px;
                border:none;
                border-radius:35px;
                background:#F7F7F7;
                padding:0 20px;
                color:#999;
				font-size:26px;
            }
            input::placeholder{
                color:#ccc;
            }
            .error-message{
                color:#bf0000;
                padding-top:6px;
                font-size:24px;
                height:24px;
                margin-bottom:30px;
                padding-left:20px;
            }
            .send-form{
                width:640px;
                height:70px;
                text-align:center;
                line-height:70px;
                color:#fff;
                font-size:24px;
                border-radius:35px;
                background:#bf0000;
                margin-bottom:60px;
                border:none;
            }
            .send-form:active{
                background:#dd8080;
            }
            .sending{
                background:#dd8080;
            }
            .invite-code-intro{
                width:520px;
                h4{
                    font-size:24px;
                    color:#535353;
                    margin-bottom:28px;
                    font-weight:bold;
                }
                p{
                    font-size:20px;
                    color:#999;
                    line-height:36px;
                }
            }
        }
    }
</style>